import {ReactNode} from 'react'
import {MenuComponent, ScrollComponent} from '../assets/ts/components'

type WithChildren = {
  children?: ReactNode
}

const reInitMenu = () => {
  setTimeout(() => {
    MenuComponent.reinitialization()
    // MasterInit bootstraps scrolls once at app start; the sidebar can mount later (slow auth check, login)
    ScrollComponent.reinitialization()
  }, 500)
}

export {type WithChildren, reInitMenu}
